import { ConfirmationDialog } from "../../../common/ConfirmationDialog";

const RemoveDeviceDialog = ({
  isOpen,
  onClose,
  onRemoveDevice,
}: {
  isOpen: boolean;
  onClose: () => void;
  onRemoveDevice: () => void;
}) => {
  return (
    <ConfirmationDialog
      isOpen={isOpen}
      confirmationMessage={"Are you sure you want to remove this device?"}
      confirmationTitle={"Remove Device"}
      onClose={onClose}
      confirmationButtonText={"Delete"}
      shouldCloseOnConfirm={true}
      onConfirmationAction={onRemoveDevice}
    />
  );
};

export default RemoveDeviceDialog;
